import PropTypes from "prop-types";

const propTypes = {
  vysledokVyjadrenia: PropTypes.shape({
    I_VYSLEDOK: PropTypes.number,
    N_VYSLEDOK: PropTypes.string,
  }),
};

export default propTypes;
